import React from "react";
import { Grid, Container } from "semantic-ui-react";

const styles = {
	sidebarTitle: {
		color: "#00a794",
		height: "100%",
		width: "100%",
		fontWeight: 600,
	},
	withMargin: {
		marginLeft: 10,
		marginBottom: 10,
	},
};
const SidebarTitle = ({ title, subtitle = null, subtitle2 = null }) => (
	<Grid.Row style={{ borderBottom: "1px solid #cecece", marginLeft: 20 }}>
		<Grid style={{ width: "100%" }}>
			<Grid.Row>
				<h3 style={styles.sidebarTitle}>{title}</h3>
			</Grid.Row>

			{subtitle !== null && <Grid.Row style={styles.withMargin}>{subtitle}</Grid.Row>}
			{subtitle2 !== null && <Grid.Row style={styles.withMargin}>{subtitle2}</Grid.Row>}
		</Grid>
	</Grid.Row>
);

export default SidebarTitle;
